const validRequired = {
    required: true,
    message: '此项不能为空',
}
const validNumber = {
    validator: (rule, value, callback) => {
        let reg = /^[1-9][0-9]*$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正整数"));
        }
    }
}
const validNumberAndZero = {
    validator: (rule, value, callback) => {
        let reg = /^\d+$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入整数"));
        }
    }
}
const validFloat2 = {
    validator: (rule, value, callback) => {
        let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正数值"));
        }
    }
}
const validIP = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return
        }
        let reg = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)($|(?!\.$)\.)){4}$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确IP"));
        }
    }
}
const validMAC = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return;
        }
        let reg = /^([0-9a-fA-F]{2})(([/\s:-][0-9a-fA-F]{2}){5})$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确MAC"));
        }
    }
}
const validPhone = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return;
        }
        let reg = /^1[3456789]\d{9}$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确手机号"));
        }
    }
}
const validcode = {
    validator: (rule, value, callback) => {

        if (!value) {
            callback();
            return;
        }
        if (value.length != 18) {
            callback(new Error("请输入正确社会统一信用代码"));
        }
        else {
            callback();
            return;
        }
    }
}
const validChinese = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return;
        }
        let reg = /^[\x00-\xff]{0,}$/
        if (!reg.test(value)) {
            callback(new Error("不允许汉字"));
        } else {
            callback();
        }
    }
}
const validLen = function (len = 10) {
    return {
        validator: (rule, value, callback) => {
            if (!value) {
                callback();
                return;
            }
            if (value.length <= len) {
                callback();
            } else {
                callback(new Error("超出最大长度" + len));
            }
        }
    }
}
const validlongitude = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return;
        }
        let reg = /^(((\d|[1-9]\d|1[1-7]\d|0)\.\d{0,8})|(\d|[1-9]\d|1[1-7]\d|0{1,3})|180\.0{0,4}|180)$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确经度"));
        }
    }
}
const validlatitude = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return;
        }
        let reg = /^([0-8]?\d{1}\.\d{0,8}|90\.0{0,4}|[0-8]?\d{1}|90)$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确纬度"));
        }
    }
}
const validVIN = {
    validator: (rule, value, callback) => {
        if (!value) {
            callback();
            return;
        }
        let reg = /^[A-Z0-9]{6}$/
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("请输入正确的VIN号"));
        }
    }
}

export default {
    validRequired,
    validNumber,
    validNumberAndZero,
    validFloat2,
    validIP,
    validMAC,
    validPhone,
    validChinese,
    validLen,
    validcode,
    validlongitude,
    validlatitude,
    validVIN
}